"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Confirm = void 0;
const react_1 = __importDefault(require("react"));
const use_confirm_1 = require("./use-confirm");
exports.Confirm = (_a) => {
    var { onConfirm, onDecline, children } = _a, props = __rest(_a, ["onConfirm", "onDecline", "children"]);
    const [Confirm, handler] = use_confirm_1.useConfirm(onConfirm, onDecline);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children(handler),
        react_1.default.createElement(Confirm, Object.assign({}, props))));
};
//# sourceMappingURL=confirm.js.map